import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemDetails = function IconSystemDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3-1a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m1 6a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2zm0 7a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2zm-3-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  }));
};